import { styled } from '@mui/system'
import { Box } from '@mui/material';

export const ServicesContainer = styled('div')((props) => ({
    display: 'flex',
    flexDirection: 'row',
    margin: '40px 40px',
    '.header-section': {
        marginRight: 20,
        flex: 1
    },
    '.services-heading': {
        color: '#fa6943',
        marginBottom: 10,
        fontWeight: 800,
        [props.theme.breakpoints.down('md')]: {
            fontSize: 35
        },
        [props.theme.breakpoints.down('sm')]: {
            fontSize: 30
        },
    },
    '.service-sub-heading': {
        color: '#fa6943',
        marginBottom: 10,
        [props.theme.breakpoints.down('sm')]: {
            fontSize: 20
        }
    }
}))

export const Service = styled(Box)((props) => ({
    backgroundColor: '#eee',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 10,
    borderRadius: 8,
    height:'80%',
    '.service-img-container':{
        width: 80,
        height: 80,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'white',
        borderRadius: '50%',
        [props.theme.breakpoints.down('md')]: {
            width: 50,
            height: 50,
            svg: {
                height: 30,
                width: 30
            }
        },
        [props.theme.breakpoints.down('sm')]: {
            width: 30,
            height: 30,
            svg: {
                height: 20,
                width: 20
            }
        }
      },
      '.service-name':{
           fontSize:20,
           marginTop: 15,
           [props.theme.breakpoints.down('md')]:{
               fontSize:13
           }
         }
}))